/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeAccessRolesPermission } from './EmployeeAccessRolesPermission';
import {
    EmployeeAccessRolesPermissionFromJSON,
    EmployeeAccessRolesPermissionFromJSONTyped,
    EmployeeAccessRolesPermissionToJSON,
    EmployeeAccessRolesPermissionToJSONTyped,
} from './EmployeeAccessRolesPermission';

/**
 * 
 * @export
 * @interface UpdateEmployeeAccessRolePermissionsResponse
 */
export interface UpdateEmployeeAccessRolePermissionsResponse {
    /**
     * 
     * @type {Array<EmployeeAccessRolesPermission>}
     * @memberof UpdateEmployeeAccessRolePermissionsResponse
     */
    data: Array<EmployeeAccessRolesPermission>;
}

/**
 * Check if a given object implements the UpdateEmployeeAccessRolePermissionsResponse interface.
 */
export function instanceOfUpdateEmployeeAccessRolePermissionsResponse(value: object): value is UpdateEmployeeAccessRolePermissionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmployeeAccessRolePermissionsResponseFromJSON(json: any): UpdateEmployeeAccessRolePermissionsResponse {
    return UpdateEmployeeAccessRolePermissionsResponseFromJSONTyped(json, false);
}

export function UpdateEmployeeAccessRolePermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeAccessRolePermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeAccessRolesPermissionFromJSON)),
    };
}

  export function UpdateEmployeeAccessRolePermissionsResponseToJSON(json: any): UpdateEmployeeAccessRolePermissionsResponse {
      return UpdateEmployeeAccessRolePermissionsResponseToJSONTyped(json, false);
  }

  export function UpdateEmployeeAccessRolePermissionsResponseToJSONTyped(value?: UpdateEmployeeAccessRolePermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeAccessRolesPermissionToJSON)),
    };
}

